module.exports = __webpack_public_path__ + "img/日历签到2.707dd8d8.png";